// extracted by mini-css-extract-plugin
export default {"container":"Section_container__6d62a","header":"Section_header__r9C+z","body":"Section_body__CNY4y"};